import cybersecurity from '../images/services/cybersecurity-oplossingen_image.webp';
import penetrationtesting from '../images/services/penetration-testing_image.webp';
import securityawareness from '../images/services/security-awareness_training.webp';
import compliance from '../images/services/compliance-regelgeving_image.webp';


// SecureScan image imports
import securescanDashboard from '../images/services/securescan/securescan_dashboard.webp';
import networkDashboard from '../images/services/securescan/network_scan_report.webp';
import threatDetection from '../images/services/securescan/threat_detection.webp';

// QuickScan image reports
import quickScanReport from '../images/services/quickscan/quickscan_report_preview.webp';
import quickDashboardForm from '../images/services/quickscan/quickscan_form.webp';
import quickDashboard from '../images/services/quickscan/quickscan_dashboard.webp';

// Security Awareness Training
import trainingModule from '../images/services/awareness_training/training_module_preview.webp';
import phishingModule from '../images/services/awareness_training/phishing_simulation.webp';
import riskModule from '../images/services/awareness_training/risk_assessment_dashboard.webp';

// Compliance section
import complianceReview from '../images/services/compliance/compliance_certification_preview.webp';
import regulationsDashboard from '../images/services/compliance/regulations_dashboard.webp';
import riskGap from '../images/services/compliance/risk_gap_assessment.webp';

const Services = [
    {
        "id": "1",
        "title": "Praeventor SecureScan",
        "slug": "securescan",
        "sImg": cybersecurity,
        "width":'2520px',
        "height":'2520px',
        "col": "col-lg-6",
        "thumb1":'Consultancy',
        "thumb2":'Strategie',
        "thumb3":'Implementatie',
        "introText": "Met Praeventor SecureScan bieden we een alles-in-één SaaS-oplossing voor proactieve netwerkbeveiliging. Onze agent wordt geïnstalleerd binnen uw netwerk en voert constante scans uit op systemen, apparaten en connecties, zodat u altijd op de hoogte bent van potentiële risico's en bedreigingen.",
        "details": [
            {
                "text": "Praeventor SecureScan is ontworpen om interne bedreigingen te detecteren voordat ze een probleem worden. Door real-time monitoring van netwerkverbindingen en systeeminteracties biedt het continue bescherming."
            },
            {
                "text": "Onze oplossing is schaalbaar en flexibel, waardoor het geschikt is voor zowel kleine als grote organisaties. Dankzij geavanceerde AI-detectie en regelmatige updates blijft SecureScan altijd een stap voor op nieuwe bedreigingen."
            }
        ],
        "howDoesItWork": "Hoe werkt het?",
        "features": [
            {
                "category": "left",
                "items": [
                    "Real-time netwerkmonitoring",
                    "Geautomatiseerde kwetsbaarhedenscans",
                    "Eenvoudige integratie en installatie"
                ]
            },
            {
                "category": "right",
                "items": [
                    "Schaalbaar en flexibel",
                    "Continue updates voor nieuwe dreigingen",
                    "Compliance-rapportages en inzichtelijke dashboards"
                ]
            }
        ],
        "imageGallery": [
            {
                "src": securescanDashboard,
                "alt": "Dashboard van Praeventor SecureScan met real-time monitoring",
                "width": "820px",
                "height": "820px"
            },
            {
                "src": networkDashboard,
                "alt": "Gedetailleerd netwerk scan rapport van SecureScan",
                "width": "820px",
                "height": "820px"
            },
            {
                "src": threatDetection,
                "alt": "Illustratie van bedreigingsdetectie binnen SecureScan",
                "width": "820px",
                "height": "820px"
            }
        ]
    },
    {
        "id": "2",
        "title": "Praeventor QuickScan",
        "slug": "quickscan",
        "sImg": penetrationtesting,
        "width":'2520px',
        "height":'2520px',
        "col": "col-lg-6",
        "thumb1":'Consultancy',
        "thumb2":'Risicoanalyse',
        "thumb3":'Directe Actie',
        "introText": "Praeventor QuickScan is onze gratis en gebruiksvriendelijke oplossing voor het uitvoeren van een externe netwerkscan. Start binnen enkele minuten een scan en ontvang een rapport over de beveiligingsstatus van uw netwerk zonder installatie.",
        "details": [
            {
                "text": "Met Praeventor QuickScan kunnen bedrijven eenvoudig een eerste beveiligingscontrole uitvoeren op hun externe netwerkverbindingen. Deze gratis tool biedt inzicht in potentiële kwetsbaarheden en helpt organisaties om hun beveiliging proactief te verbeteren."
            },
            {
                "text": "Door het invullen van een eenvoudig formulier kunnen bedrijven direct een scan opstarten. Binnen enkele minuten ontvangt u een basisrapport met aanbevelingen en beveiligingsinzichten."
            }
        ],
        "howDoesItWork": "Hoe werkt het?",
        "features": [
            {
                "category": "left",
                "items": [
                    "Direct online starten via formulier",
                    "Geen installatie nodig",
                    "Snel en gebruiksvriendelijk"
                ]
            },
            {
                "category": "right",
                "items": [
                    "Basisrapport binnen enkele minuten",
                    "Inzicht in beveiligingsrisico's",
                    "Aanbevelingen voor verbeteringen"
                ]
            }
        ],
        "callToAction": {
            "text": "Start nu uw gratis scan",
            "formLink": "/start-quickscan"
        },
        "imageGallery": [
            {
                "src": quickScanReport,
                "alt": "Voorbeeld van QuickScan rapport met beveiligingsanalyse",
                "width": "820px",
                "height": "820px"
            },
            {
                "src": quickDashboardForm,
                "alt": "Gebruiksvriendelijk formulier om QuickScan te starten",
                "width": "820px",
                "height": "820px"
            },
            {
                "src": quickDashboard,
                "alt": "Dashboard met overzicht van beveiligingsrisico's gedetecteerd door QuickScan",
                "width": "820px",
                "height": "820px"
            }
        ]
    },
    {
        "id": "3",
        "title": "Security Awareness Training",
        "slug": "security-awareness-training",
        "sImg": securityawareness,
        "width":'1640px',
        "height":'1900px',
        "col": 'col-lg-4',
        "thumb1":'Phishing',
        "thumb2":'Data bescherming',
        "thumb3":'Proactieve cultuur',
        "introText": "Praeventor Security Awareness Training biedt een praktische, hands-on aanpak om uw medewerkers te wapenen tegen cyberdreigingen zoals phishing en datalekken. Onze trainingen helpen uw team om bewuste en veilige beslissingen te nemen in hun dagelijkse werk.",
        "details": [
            {
                "text": "Onze Security Awareness Training richt zich op het verbeteren van de beveiligingskennis en -vaardigheden van medewerkers. Door interactieve modules en realistische scenario’s worden deelnemers bewust van de risico’s van cyberaanvallen en leren zij hoe zij deze kunnen vermijden."
            },
            {
                "text": "Onze training behandelt essentiële onderwerpen zoals phishing, dataprotectie, en wachtwoordbeheer, en helpt organisaties aan de hoogste compliance-standaarden te voldoen."
            }
        ],
        "howDoesItWork": "Hoe werkt het?",
        "features": [
            {
                "category": "left",
                "items": [
                    "Interactieve phishing simulaties",
                    "Datalek-preventie oefeningen",
                    "Compliance en beleidstraining"
                ]
            },
            {
                "category": "right",
                "items": [
                    "Real-time kennisquizzen",
                    "Aanpasbare trainingsmodules",
                    "Rapportages voor inzicht in risiconiveaus"
                ]
            }
        ],
        "callToAction": {
            "text": "Plan een training in!",
            "formLink": "/awareness-training"
        },
        "imageGallery": [
            {
                "src": trainingModule,
                "alt": "Voorbeeld van een beveiligingstrainingmodule",
                "width": "820px",
                "height": "820px"
            },
            {
                "src": riskModule,
                "alt": "Dashboard met resultaten van risicobeoordeling en trainingsvoortgang",
                "width": "820px",
                "height": "820px"
            },
            {
                "src": phishingModule,
                "alt": "Phishing simulatie voorbeeld in de Security Awareness Training",
                "width": "820px",
                "height": "820px"
            }
        ]
    },
    // {
    //     Id: '4',
    //     sImg:cloudsecurity,
    //     title: 'Cloud Security en DevSecOps',
    //     slug: 'Modern-Technology-Solution',
    //     thumb1:'Containers',
    //     thumb2:'CI/CD',
    //     col:'col-lg-4',
    //     description:'Embarking on a journey of higher education in a foreign country opens doors to...',
    // },
    {
        "id": "4",
        "title": "Compliance en Regelgeving",
        "slug": "compliance-en-regelgeving",
        "sImg": compliance,
        "width":'1640px',
        "height":'1900px',
        "col": 'col-lg-4',
        "thumb1":'Certificering',
        "thumb2":'Audit',
        "introText": "Praeventor Compliance en Regelgeving biedt uw organisatie de ondersteuning en expertise om te voldoen aan internationale en lokale veiligheidsnormen zoals ISO27001, NEN, en NIS2. Ons team helpt u om soepel en efficiënt te navigeren door complexe regelgevingen en zorgt ervoor dat uw bedrijf altijd compliant blijft.",
        "details": [
            {
                "text": "Onze Compliance en Regelgeving service zorgt ervoor dat uw organisatie voldoet aan de strengste veiligheidsstandaarden, waaronder ISO27001, NEN, en de nieuwe NIS2-richtlijnen. Wij bieden praktische ondersteuning, begeleiding en periodieke audits om risico’s te minimaliseren en uw beveiligingsframework te versterken."
            },
            {
                "text": "Met onze compliance-dienst blijft uw organisatie altijd voorbereid op veranderende wetgeving en kunt u vertrouwen op onze expertise voor naleving van de hoogste beveiligingsnormen, die uw bedrijfscontinuïteit en reputatie beschermen."
            }
        ],
        "howDoesItWork": "Hoe werkt het?",
        "features": [
            {
                "category": "left",
                "items": [
                    "Volledige ondersteuning voor ISO27001 certificering",
                    "Praktische hulp bij NEN en NIS2 naleving",
                    "Risico-analyse en gap-assessments"
                ]
            },
            {
                "category": "right",
                "items": [
                    "Aanpasbare compliance training",
                    "Regelmatige audits en rapportages",
                    "Up-to-date advies over wetgevingsveranderingen"
                ]
            }
        ],
        "callToAction": {
            "text": "Ontvang een gratis compliance consult",
            "formLink": "/request-compliance-consult"
        },
        "imageGallery": [
            {
                "src": complianceReview,
                "alt": "Voorbeeld van compliance-certificering en audits",
                "width": "820px",
                "height": "820px"
            },
            {
                "src": regulationsDashboard,
                "alt": "Dashboard met naleving en voortgang van regelgeving",
                "width": "820px",
                "height": "820px"
            },
            {
                "src": riskGap,
                "alt": "Illustratie van risicobeoordeling en gap-analyse",
                "width": "820px",
                "height": "820px"
            }
        ]
    },
]    

export default Services;